import React from 'react';
import UserWelcomeInfo from './user-welcome-info';
import UserSection from './user-section';
import './Header.scss';

const Header = () => {
  return (
    <header className="dashboard-header">
      <div className="header-content">
        {/* Left side - Welcome Info */}
        <div className="header-left">
          <UserWelcomeInfo />
        </div>

        {/* Right side - User Section */}
        <div className="header-right">
          <UserSection />
        </div>
      </div>

    </header>
  );
};

export default Header;